import React from 'react';
import { useFormContext } from 'react-hook-form';
import { updatePageFormDirtyState } from '../../../actions/catalogue/catalogue/update';
import { AsyncDispatch } from '../../../../types/global';
import { useAppDispatch } from '../../../store/ReduxStore';

const PageHookFormDirtyHandler: React.FC = () => {
  const dispatch: AsyncDispatch = useAppDispatch();
  const { formState } = useFormContext();
  const { isDirty } = formState;

  React.useEffect(() => {
    dispatch(updatePageFormDirtyState(isDirty));
  }, [isDirty, dispatch]);

  // Cleanup on unmount
  React.useEffect(() => {
    return () => {
      dispatch(updatePageFormDirtyState(false));
    };
  }, [dispatch]);

  return null;
};

export default PageHookFormDirtyHandler;
